import { useRef, useState } from 'react';

import { List, Modal } from 'antd';
import Button from 'app/components/Button';
import Panel from 'app/components/Layout/Panel';
import classes from './Style.module.scss';
import { Formik, useFormikContext } from 'formik';
import Edit from './Edit';
import POItems from '../../../InspectionCriteria/EnhancedPoItem';
// import POItem from '../../../InspectionCriteria/PoItem';

const Report = (props) => {
  const formikRef = useRef(null);
  const { values, setValues } = useFormikContext();

  const { inspectionRequirement }: any = values;
  const [edit, setEdit] = useState(false);
  const { value } = props;
  return (
    <Panel
      className={classes.report}
      title="B) Report Detail"
      extra={
        <Button
          type="link"
          onClick={() => {
            setEdit(true);
          }}
        >
          Edit
        </Button>
      }
    >
      <POItems poItems={value} className={classes.list} hideTemplate />
      {/* <List
        className={classes.list}
        dataSource={value || []}
        split={false}
        renderItem={(record: any, index) => {
          return (
            <P
            // <POItem
            //   hiddenTemplate
            //   className={classes.item}
            //   value={record}
            //   index={index}
            //   inspectionRequirement={inspectionRequirement}
            // />
          );
        }}
      ></List> */}
      <Modal
        open={edit}
        title="Report Detail"
        width="80%"
        cancelButtonProps={{ hidden: true }}
        onOk={() => {
          formikRef.current.submitForm();
          setEdit(false);
        }}
        onCancel={() => {
          setEdit(false);
        }}
        okText="Confirm"
        bodyStyle={{
          maxHeight: 650,
          overflowY: 'auto',
        }}
      >
        <Formik
          initialValues={values}
          enableReinitialize
          onSubmit={(values) => {
            setValues(values);
          }}
        >
          {(formikProps) => {
            formikRef.current = formikProps;
            return <Edit />;
          }}
        </Formik>
      </Modal>
    </Panel>
  );
  // return (
  //   <div>
  //     <WrapperFormTitle>
  //       <FormTitle>{`B) Report Detail`}</FormTitle>
  //       <Button
  //         type="link"
  //         onClick={() => {
  //           setOpenReportDetail(true);
  //         }}
  //       >
  //         Edit
  //       </Button>
  //     </WrapperFormTitle>
  //     {/* <Form.List name="products">
  //       {(fields) => {
  //         return fields.map((field, index) => {
  //           const inspection = form.getFieldValue(['products', field.name]);
  //           const requirement = form.getFieldValue(['inspectionRequirement']);
  //           const { productProfile: product } = inspection;
  //           return (
  //             <InspectionJobItem
  //               skipFetchSampleSize
  //               key={index}
  //               productProfile={product}
  //               numOfItem={index + 1}
  //               inspection={inspection}
  //               requirement={requirement}
  //             ></InspectionJobItem>
  //           );
  //         });
  //       }}
  //     </Form.List> */}
  //     {/* <ModalEditReportProduct
  //       open={openReportDetail}
  //       products={form.getFieldValue(['products'])}
  //       onCancel={() => {
  //         setOpenReportDetail(false);
  //       }}
  //       onOk={(values) => {
  //         form.setFieldValue('products', values);
  //         setOpenReportDetail(false);
  //       }}
  //     ></ModalEditReportProduct> */}
  //   </div>
  // );
};

export default Report;
